export class FinanceCnGeneratedDialogModel {
    constructor(
        public invoices: any
    ) {}
}